import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import asButton from '../decorator/asButton';
import IconComponent from './Icon';
import './ItemListSelection.css';

const ItemListSelection = ({ id, toggle, allSelected, shown, selectedItems, onItemSelect }) => {
  const [selection, setSelection] = useState(false);

  useEffect(() => {
    setSelection(toggle);
  }, [toggle]);

  const selectItem = (e, i) => {
    setSelection(!selection);
    if (onItemSelect) {
      onItemSelect(e, i);
    }
  };

  if (selection && !selectedItems?.length) {
    setSelection(false);
  }

  const getIcon = () => {
    if (
      (id === 'ALL' || allSelected) &&
      selectedItems?.length > 0 &&
      selectedItems?.length !== shown
    ) {
      return 'icon-subtract-square';
    }
    return selection ? 'icon-check-2' : 'icon-keyboard-button';
  };

  return (
    <aside
      className="itemListSelection"
      data-selected={selection}
      {...asButton(id, 'itemListSelectItem', selectItem, id)}>
      <IconComponent src={getIcon()} caption={selection ? 'Selected' : 'Not selected'} />
    </aside>
  );
};

ItemListSelection.propTypes = {
  id: PropTypes.string.isRequired,
  toggle: PropTypes.bool,
  allSelected: PropTypes.bool,
  shown: PropTypes.number,
  selectedItems: PropTypes.arrayOf(PropTypes.string),
  onItemSelect: PropTypes.func
};

ItemListSelection.defaultProps = {
  toggle: false,
  allSelected: false,
  shown: 0,
  selectedItems: [],
  onItemSelect: () => {}
};

export default ItemListSelection;
